import React from "react";
import { Navbar } from "../components/shared/Navbar";
import { HomeBanner } from "./components/HomeBanner";
import backgroundImage from '../assets/images/LockBG.jpeg';
import { Services } from "./components/Services";
import { Trust } from "./components/Trust";
import { Insights } from "./components/Insights";
import { Testimonials } from "./components/Testimonials";
import { Cta20 } from "./components/Cta20";
import { Footer2 } from "../components/shared/Footer2";

export default function Home() {
  return (
    <div className="font-noto">
      <div
       id="relume-header"  
       style={{ backgroundImage: `url(${backgroundImage})` }}
       className="bg-cover  bg-center bg-no-repeat min-h-600px]">
        <Navbar />
        <HomeBanner />
      </div>
      <Services />
      <Trust />
      <Testimonials />
      <Insights />
      <Cta20 />
      <Footer2 />
    </div>
  );
}
